<template>
  <DialogTemplate>
    <div class="weight_700 text-semi-large d-flex">
      <!-- <i
        class="mdi mdi-information-outline text-large my-auto mr-2 clr-error"
      ></i> -->
      <div class="my-auto">
        <!-- {{ $t(`messages.${title}`) }} -->
        {{ $t(`messages.trainer_game_in_progress`) }}
      </div>
    </div>
    <div
      style="max-width: 20rem"
      class="pb-4 pt-1 text-medium clr-grey"
    >
      <!-- {{ $t(`messages.${sub}`) }} -->
      {{ $t(`messages.trainer_current_game_will_cancel`) }}
    </div>
    <template #dialog_actions>
      <v-btn
        class="ml-auto mr-2"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
      <v-btn
        color="primary"
        @click="apply"
      >
        {{ $t('btn.continue') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'TrainerRestoreHandDialog',
  components: {
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {}
  },
  methods: {
    apply() {
      if (this.action === 'startdrill') {
        this.$store.dispatch('drills_start_drill', {
          drill: this.$store.getters.drills_selected_drill,
        })
        return
      }
      if (this.action === 'playtablesession') {
        this.$store.dispatch('globals_action', 'playtablesession_apply')
        return
      }

      this.close() // calling close before restore_hand leads to unfinished routing in trainer_restore_hand
      this.$store.dispatch(`tra/replay/trainer_restore_hand`, { action: this.action })
    },
    close() {
      this.$store.dispatch('router_reset_dialogs')
    },
  },
  computed: {
    action() {
      return this.dialog.action
    },
  },
}
</script>

<style lang="scss" scoped>
.rb-dialog_action {
  border-radius: 4px;
  text-shadow: var(--text-shadow_drop);
  min-width: 6rem;
}
</style>
